const $ = jQuery.noConflict();

'use strict';
const PageAnchor = {
	init: function() {
		this.anchorAnimation();

		$('.js-mobile-navigation').on('click', function() {
			$('.js-page-anchor-wrap').toggleClass('show');
		});

		$('.page-anchor__link').on('click', function() {
			$('.js-page-anchor-wrap').removeClass('show');
		});
	},

	anchorAnimation: function() {
		const component = $('.page-anchor__sections');
		const nav = $('.js-page-anchor-navigation');

		$(window).on('scroll load', function() {
			const curPos = $(this).scrollTop();

			component.each(function() {
				const top = $(this).offset().top - 200;
				const bottom = top + $(this).outerHeight();

				if (curPos >= top && curPos <= bottom) {
					nav.find('a').removeClass('active');
					component.removeClass('active');

					$(this).addClass('active');
					nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
				}
			});
		});

		nav.find('a').on('click', function() {
			const $el = $(this);
			const id = $el.attr('href');

			setTimeout(() => {
				$('html, body').animate({
					scrollTop: $(id).offset().top - 100
				}, 300);
			}, 300);

			return false;
		});

		const pageAnchor = $('.page-anchor');
		if (pageAnchor.length) {
			const offsetTopPosition = $(pageAnchor).offset().top - $(window).scrollTop();
			$(window).on('scroll', function() {
				const offsetTopPosition = $(pageAnchor).offset().top - $(window).scrollTop();
				if (offsetTopPosition < 100) {
					$('.js-page-anchor-wrap').addClass('sticky');
					$('.js-site-header').addClass('extra-header');
				} else {
					$('.js-page-anchor-wrap').removeClass('sticky');
					$('.js-site-header').removeClass('extra-header');
				}
			});
			if (offsetTopPosition < 100) {
				$('.js-page-anchor-wrap').addClass('sticky');
				$('.js-site-header').addClass('extra-header');
			} else {
				$('.js-page-anchor-wrap').removeClass('sticky');
				$('.js-site-header').removeClass('extra-header');
			}
		}
	}
};

export default PageAnchor;
